import React, { useState, useEffect, useRef } from 'react';
import { Button, Table, Dropdown, Carousel, Popover, Empty } from 'antd';
import { RightOutlined } from '@ant-design/icons';
import { Config } from '../../public/js/config';
import moment from 'moment';//日期格式化导包
import { Base } from '../../public/js/base';
import { ContextHandler } from '../../public/js/contextHandler';
import context from '../../public/js/context';
import NewMessage from '../../component/newMessage/newMessage';
import { useHistory } from 'react-router-dom';
import './studentHome.css'
import { studentCheckLogin } from '../newMain/studentMain';

import vectorImg from '../../public/img/newMain/Vector.png'
import stdApplyingAction from '../../public/img/newMain/stdApplyingAction.png'
import rightArrow from '../../public/img/newMain/RightArrow.png'
import exportImg from '../../public/img/newMain/Export.png'
import select1 from '../../public/img/std/select1.png'
import select3 from '../../public/img/std/select3.png'
import inspectImg from '../../public/img/newMain/Inspect.png'
import sortImg from '../../public/img/newMain/Sort.png'
import resetImg from '../../public/img/newMain/Reset.png'
import searchImg from '../../public/img/newMain/Search.png'
import studentDefaultPictureImg from '../../public/img/newMain/studentDefaultPicture.png'
import StudentSeeAllJobApplicationsSort from '../studentSeeAllJobApplications/studentSeeAllJobApplicationsSort';
import tips from '../../public/img/tips.png';
import leftArrow from '../../public/img/newMain/leftArrow.png';

const StudentHome = (props) => {
    const messageRef = useRef();
    const messageRefAssignd = useRef();
    const history = useHistory();
    const [tablesCount, setTablesCount] = useState(0);
    const [tables, setTables] = useState([]);
    const [current, setCurrent] = useState(1);
    const [pageSize, setPageSize] = useState(10);

    const [tablesJob, setTablesJob] = useState([]);
    const [tablesJobOrigin, setTablesJobOrigin] = useState([]);
    const [tablesCountJob, setTablesCountJob] = useState(0);
    const [tablesOffer, setTablesOffer] = useState([]);
    const [tablesOfferOrigin, setTablesOfferOrigin] = useState([]);
    const [tablesCountOffer, setTablesCountOffer] = useState(0);
    const [tablesDocument, setTablesDocument] = useState([]);
    const [tablesDocumentOrigin, setTablesDocumentOrigin] = useState([]);
    const [tablesCountDocument, setTablesCountDocument] = useState(0);
    const [tablesRejected, setTablesRejected] = useState([]);
    const [tablesRejectedOrigin, setTablesRejectedOrigin] = useState([]);
    const [tablesCountRejected, setTablesCountRejected] = useState(0);
    const [tablesSpecial, setTablesSpecial] = useState([]);
    const [tablesSpecialOrigin, setTablesSpecialOrigin] = useState([]);
    const [tablesCountSpecial, setTablesCountSpecial] = useState(0);
    const [tablesAssigned, setTablesAssigned] = useState([]);
    const [tablesAssignedOrigin, setTablesAssignedOrigin] = useState([]);
    const [tablesCountAssigned, setTablesCountAssigned] = useState(0);

    const carouselRef = useRef();
    const carouselRefOffer = useRef();
    const carouselRefDocument = useRef();
    const carouselRefRejected = useRef();
    const carouselRefSpecial = useRef();
    const carouselRefAssigned = useRef();
    const [jobApplCountMap, setJobApplCountMap] = useState({});

    const [jobPostModel, setJobPostModel] = useState({});
    const [popoverVisible, setPopoverVisible] = useState(false);
    const [jobSortPostModel, setJobSortPostModel] = useState({});
    const [isReset, setIsReset] = useState(false);
    const [size, setSize] = useState(0);
    const [isFirstShow, setIsFirstShow] = useState(true);
    const [isFirstRender, setIsFirstRender] = useState(true);
    const jobPostModelRef = useRef({});
    const [moduleList, setModuleList] = useState([]);

    useEffect(() => {
        studentCheckLogin();
        handleResize();
        window.addEventListener('resize', handleResize);
        search(10, 1);
        searchJobApplCount();
        searchModuleList();
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if (isFirstRender) {
            setIsFirstRender(false);
            return;
        }
        if (isFirstShow) {
            searchJob()
            searchOffer()
            searchDocument()
            searchRejected()
            searchSpecial()
            searchAssigned()
            setIsFirstShow(false)
        } else {
            let tablesJobNew = processingdata(tablesJobOrigin);
            setTablesJob(tablesJobNew);
            let tablesOfferNew = processingdata(tablesOfferOrigin);
            setTablesOffer(tablesOfferNew);
            let tablesDocumentNew = processingdata(tablesDocumentOrigin);
            setTablesDocument(tablesDocumentNew);
            let tablesRejectedNew = processingdata(tablesRejectedOrigin);
            setTablesRejected(tablesRejectedNew);
            let tablesSpecialNew = processingdata(tablesSpecialOrigin);
            setTablesSpecial(tablesSpecialNew);
            let tablesAssignedNew = processingdata(tablesAssignedOrigin);
            setTablesAssigned(tablesAssignedNew);
        }
    }, [size]);

    const handleResize = () => {
        if (window.innerWidth <= 1408) {
            setSize(4)
        } else (
            setSize(3)
        )
    };

    const search = (pageSizeNew, current, flag, jobModel) => {
        let model = {}
        if (jobSortPostModel) {
            model = { ...jobSortPostModel }
        }
        if (jobModel) {
            model = { ...jobModel }
        }
        model.jobTitle = flag ? '' : jobPostModelRef.current.jobTitle
        model.statusTypeList = ['APPLY', 'OFFER_REPLY']
        model.studentModuleId = Config.studentInfo?.studentId
        model.pageSize = pageSizeNew
        model.startRow = (current - 1) * pageSizeNew
        model.page = current
        Base.callBackApi("jobAppl/search", model).then((data) => {
            if ("SUCCESS" === data?.msg) {
                setTablesCount(data?.object?.total ?? 0);
                setTables(data?.object?.list ?? []);
                setCurrent(current);
                setPageSize(pageSizeNew);
            } else {
                console.log(data?.msg)
            }
        })
    }

    const reset = () => {
        jobPostModelRef.current = {};
        setJobPostModel({});
        setJobSortPostModel({})
        setIsReset(true)
        search(10, 1, true, {});
    }

    const modelChange = (key, value) => {
        setJobPostModel(model => {
            jobPostModelRef.current = { ...model, ...{ [key]: value } };
            return { ...model, ...{ [key]: value } };
        });
        search(pageSize, 1);
    }

    const processingdata = (draftList) => {
        let draftListNew = [];
        let index = 0;
        for (var i = 0; i < draftList.length; i += size) {
            draftListNew[index] = []
            for (var j = 0; j < size; j++) {
                let item = draftList[i + j]
                if (item) {
                    draftListNew[index][j] = item
                }
            }
            index++
        }
        return draftListNew;
    }

    const tablesJobHandleSwitch = () => {
        carouselRef.current.next()
    }

    const tablesOfferHandleSwitch = () => {
        carouselRefOffer.current.next()
    }

    const tablesDocumentHandleSwitch = () => {
        carouselRefDocument.current.next()
    }

    const tablesRejectedHandleSwitch = () => {
        carouselRefRejected.current.next()
    }

    const tablesSpecialHandleSwitch = () => {
        carouselRefSpecial.current.next()
    }

    const tablesAssignedHandleSwitch = () => {
        carouselRefAssigned.current.next()
    }

    const searchJobApplCount = () => {
        let model = {
            studentModuleId: Config.studentInfo?.studentId
        };
        Base.callBackApi("jobAppl/searchJobApplCount", model).then((data) => {
            if ("SUCCESS" === data?.msg) {
                let jobApplCountList = data.object ?? {};
                let tempMap = {}
                jobApplCountList?.map(item => {
                    tempMap[item.jobApplStatus] = item.statusCount
                })
                setJobApplCountMap(tempMap)
            } else {
                console.log(data?.msg)
            }
        })
    }

    const searchAssigned = () => {
        let model = {
            studentId: Config.studentInfo?.studentId
        };
        Base.callBackApi("studentJob/searchAssigned", model).then((data) => {
            if ("SUCCESS" === data?.msg) {
                let originList = data?.object?.list ?? [];
                setTablesAssignedOrigin(originList);
                let list = processingdata(originList);
                setTablesCountAssigned(data?.object?.total ?? 0)
                setTablesAssigned(list);
            } else {
                console.log(data?.msg)
            }
        })
    }

    const searchOffer = () => {
        let model = {
            statusType: 'APPLY',
            jobApplStatus: 'OFFER',
            studentModuleId: Config.studentInfo?.studentId
        };
        Base.callBackApi("jobAppl/search", model).then((data) => {
            if ("SUCCESS" === data?.msg) {
                let originList = data?.object?.list ?? [];
                setTablesOfferOrigin(originList);
                let list = processingdata(originList);
                setTablesCountOffer(data?.object?.total ?? 0);
                setTablesOffer(list);
            } else {
                console.log(data?.msg)
            }
        })
    }

    const searchDocument = () => {
        let model = {
            statusType: 'APPLY',
            jobApplStatusList: ['REQUEST_DOCUMENT'],
            studentModuleId: Config.studentInfo?.studentId
        };
        Base.callBackApi("jobAppl/search", model).then((data) => {
            if ("SUCCESS" === data?.msg) {
                let originList = data?.object?.list ?? [];
                setTablesDocumentOrigin(originList);
                let list = processingdata(originList);
                setTablesCountDocument(data?.object?.total ?? 0);
                setTablesDocument(list);
            } else {
                console.log(data?.msg)
            }
        })
    }

    const searchRejected = () => {
        let model = {
            statusType: 'APPLY',
            jobApplStatusList: ['REJECTED'],
            studentModuleId: Config.studentInfo?.studentId
        };
        Base.callBackApi("jobAppl/search", model).then((data) => {
            if ("SUCCESS" === data?.msg) {
                let originList = data?.object?.list ?? [];
                setTablesRejectedOrigin(originList);
                let list = processingdata(originList);
                setTablesCountRejected(data?.object?.total ?? 0);
                setTablesRejected(list);
            } else {
                console.log(data?.msg)
            }
        })
    }

    const searchSpecial = () => {
        let model = {
            statusType: 'APPLY',
            jobApplStatusList: ['SPECIAL_ARRANGEMENT'],
            studentModuleId: Config.studentInfo?.studentId
        };
        Base.callBackApi("jobAppl/search", model).then((data) => {
            if ("SUCCESS" === data?.msg) {
                let originList = data?.object?.list ?? [];
                setTablesSpecialOrigin(originList);
                let list = processingdata(originList);
                setTablesCountSpecial(data?.object?.total ?? 0);
                setTablesSpecial(list);
            } else {
                console.log(data?.msg)
            }
        })
    }

    const searchJob = () => {
        let model = {};
        model.pageSize = 12;
        model.startRow = 0;
        model.progCode = Config.studentInfo?.progCode
        Base.callBackApi("studentJob/search", model).then((data) => {
            if ("SUCCESS" === data?.msg) {
                let originList = data?.object?.list ?? [];
                setTablesJobOrigin(originList);
                let list = processingdata(originList);
                setTablesCountJob(data?.object?.total ?? 0)
                setTablesJob(list);
            } else {
                console.log(data?.msg)
            }
        })
    }

    const jump = (path) => {
        history.push(path)
    }
    
    const jumpStorage = (path, studentModuleId) => {
        localStorage.setItem(Config.tokenPrefix + 'studentModuleId', studentModuleId);
        history.push(path);
    }

    const accept = (model, flag) => {
        let jobApplModel = {
            jobApplId: flag ? model.jobApplId : model.jobApplId2,
            jobId: flag ? model.jobId : model.jobId2,
            lastUpdatedDate: flag ? model.lastUpdatedDate : model.lastUpdatedDate2,
        }
        Base.callBackApi("studentJob/acceptOffer", jobApplModel).then((data) => {
            if ("SUCCESS" === data?.msg) {
                messageRef.current.setIsShow(true)
                messageRef.current.setContent("You've successfully accepted the offer for the position of " + model.jobTitle + " at " + model.companyName)
            } else {
                console.log(data?.msg)
            }
        })
    }

    const decline = (model, flag) => {
        let jobApplModel = {
            jobApplId: flag ? model.jobApplId : model.jobApplId2,
            jobId: flag ? model.jobId : model.jobId2,
            lastUpdatedDate: flag ? model.lastUpdatedDate : model.lastUpdatedDate2,
        }
        Base.callBackApi("studentJob/declinedOffer", jobApplModel).then((data) => {
            if ("SUCCESS" === data?.msg) {
                messageRef.current.setIsShow(true)
                messageRef.current.setStatusFlag(false)
                messageRef.current.setContent("You've successfully declined the offer for the position of " + model.jobTitle + " at " + model.companyName)
            } else {
                console.log(data?.msg)
            }
        })
    }

    const done = () => {
        messageRef.current.setIsShow(false)
        searchOffer()
    }

    const doneAssignd = () => {
        messageRefAssignd.current.setIsShow(false)
        Config.studentInfo.jobApplied += 1
        Config.studentInfo.jobOffered += 1
        searchAssigned()
    }

    const assignedAccept = (model, flag) => {
        let jobApplModel = {
            studentModuleId: Config.studentInfo?.studentId,
            jobId: flag ? model.jobId : model.jobId2,
        }
        Base.callBackApi("studentJob/assignedAccept", jobApplModel).then((data) => {
            if ("SUCCESS" === data?.msg) {
                messageRefAssignd.current.setIsShow(true)
                messageRefAssignd.current.setContent("You've successfully accepted the offer for the position of " + model.jobTitle + " at " + model.companyName)
            } else {
                console.log(data?.msg)
            }
        })
    }

    const assignedDecline = (model, flag) => {
        let jobApplModel = {
            studentModuleId: Config.studentInfo?.studentId,
            jobId: flag ? model.jobId : model.jobId2,
        }
        Base.callBackApi("studentJob/assignedDecline", jobApplModel).then((data) => {
            if ("SUCCESS" === data?.msg) {
                messageRefAssignd.current.setIsShow(true)
                messageRefAssignd.current.setStatusFlag(false)
                messageRefAssignd.current.setContent("You've successfully declined the offer for the position of " + model.jobTitle + " at " + model.companyName)
            } else {
                console.log(data?.msg)
            }
        })
    }

    //分页 页码切换变化查询
    const onChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, currentNew);
    }

    //分页 每页條數变化查询
    const onShowSizeChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, 1);
    }

    const tableColumns = {
        jobId: "job_id",
        jobTitle: "job_title",
        progTitle: "prog_title",
        companyName: "company_name",
        applyDate: "apply_date",
        jobApplStatus: "job_appl_status",
    }

    const handleTableChange = (pagination, filters, sorter) => {
        let orderBy = "";
        if (sorter.field) {
            if (sorter.order === "ascend") {
                orderBy = tableColumns[sorter.field];
            } else if (sorter.order === "descend") {
                orderBy = tableColumns[sorter.field] + " DESC";
            }
        }
        if (!!sorter.field || !!jobSortPostModel.orderBy) {
            if (orderBy !== jobSortPostModel.orderBy) {
                jobSortPostModel.orderBy = orderBy;
                search(10, 1)
            }
        }
    }

    const handleOpenChange = (newOpen) => {
        setPopoverVisible(newOpen);
    };

    const handleOpenChange2 = (newOpen, status, jobSortJobPostModel) => {
        if (status) {
            setJobSortPostModel(jobSortJobPostModel)
            search(pageSize, 1, false, jobSortJobPostModel)
        }
        setIsReset(false)
        setPopoverVisible(newOpen);
    };

    const searchModuleList = () => {
        let model = {};
        model.studentId = Config.studentInfo?.studentId;
        Base.callBackApi("studentModule/search", model).then((data) => {
            if ("SUCCESS" === data?.msg) {
                let list = data?.object ?? [];
                setModuleList(list);
            } else {
                console.log(data?.msg)
            }
        })
    }

    /*eslint-disable*/
    const columns = [
        {
            title: 'Job ID',
            dataIndex: 'jobId',
            className: 'tableWidth11',
            render: text => text ? '#' + text : '',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'jobId') },
        },
        {
            title: 'Job Title',
            dataIndex: 'jobTitle',
            className: 'tableWidth26',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'jobTitle') },
        },
        {
            title: 'THEi Programme',
            dataIndex: 'progTitle',
            className: 'tableWidth29',
            render: text => (
                <Popover content={text} title="" trigger="hover">
                    <div className='tableProgramme'>{text}</div>
                </Popover>
            ),
            sorter: (a, b) => { return Base.sortMethod(a, b, 'progTitle') },
        },
        {
            title: 'Company Name',
            dataIndex: 'companyName',
            className: 'tableWidth19',
            render: (text, record) => (
                <Popover content={text} title="" trigger="hover">
                    <div className='tableProgramme'>{text}</div>
                </Popover>
            ),
            sorter: (a, b) => { return Base.sortMethod(a, b, 'companyName') },
        },
        {
            title: 'Application Date',
            dataIndex: 'applyDate',
            className: 'tableWidth15',
            render: text => text ? moment(text).format(Config.dateFormatEn) : '',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'applyDate') },
        },
        {
            title: 'Status',
            dataIndex: 'jobApplStatus',
            width: 180,
            render: text => (
                <div className='tableStatusBox'>
                    {context.jobApplStatusMap.map(item => item.value === text && <div className={'tableStatus ' + item.value}>
                        {item.label}
                    </div>)}
                </div>
            ),
            sorter: (a, b) => { return Base.sortMethod(a, b, 'jobApplStatus') },
        },
        {
            title: 'Action',
            dataIndex: 'jobApplId',
            fixed: 'right',
            width: 80,
            render: text => (
                <div className='tableAction' onClick={() => jump('/student/studentApplyJobDetail/' + text)}><img src={exportImg} /></div>
            )
        },
    ];
    /*eslint-disable*/

    return (
        <div id="container" className='websiteTemplate studentHome'>
            <NewMessage ref={messageRef} done={done} />
            <NewMessage ref={messageRefAssignd} done={doneAssignd} />
            <div className='overviewRow'>
                <div className='overviewBox'>
                    <div className='flexBox homeTitle'>Job Placement Overview</div>
                    <div className='jobPlacementOverview'>
                        <div className='countTitleBox'>
                            <div className='cardSubTitle'>Key Statistics</div>
                        </div>
                        {/* <div className='flexBox'>
                            <div className='label'>Job Post Available</div>
                            <div className='value'>{tablesCountJob}</div>
                        </div> */}
                        <div className='flexBox'>
                            <div className='label'>Cumulative Job Application</div>
                            <div className='value'>{Config.studentInfo?.jobApplied}</div>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>Cumulative Job Offer from IP</div>
                            <div className='value'>{(jobApplCountMap['OFFER'] ?? 0) + (jobApplCountMap['IN_PROGRESS'] ?? 0) + (jobApplCountMap['OFFER_DECLINED'] ?? 0)}</div>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>Cumulative Job Offer Accepted by Student</div>
                            <div className='value'>{jobApplCountMap['IN_PROGRESS'] ?? 0}</div>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>Cumulative Job Offer Rejected by Student</div>
                            <div className='value'>{jobApplCountMap['OFFER_DECLINED'] ?? 0}</div>
                        </div>
                        <div className='flexBox'>
                            <div className='label'>Current In-Progress Job Application</div>
                            <div className='value'>
                                {
                                    (jobApplCountMap['TEACHER_REVIEWING'] ?? 0)
                                    + (jobApplCountMap['PEND_IP_RECEIPT'] ?? 0)
                                    + (jobApplCountMap['IP_PROCESSING'] ?? 0)
                                    + (jobApplCountMap['SPECIAL_ARRANGEMENT'] ?? 0)
                                    + (jobApplCountMap['REQUEST_DOCUMENT'] ?? 0)
                                    + (jobApplCountMap['DOCUMENT_ATTACHED'] ?? 0)
                                    + (jobApplCountMap['OFFER'] ?? 0)
                                }
                            </div>
                        </div>
                        <div className='flexBoxMax'></div>
                        <div className='countTitleBox'>
                            <div className='cardSubTitle'>Alert</div>
                        </div>
                        <div className='flexBox selectRow' onClick={() => jump('/student/studentSeeAllJobApplications/rejected')}>
                            <div className='label'>MC Rejected Job Application</div>
                            <div className='value selectRowValue'>{jobApplCountMap['REJECTED'] ?? 0}<RightOutlined /></div>
                        </div>
                        <div className='flexBox selectRow' onClick={() => jump('/student/studentSeeAllJobApplications/special')}>
                            <div className='label'>MC Triggers Special Arrangement</div>
                            <div className='value selectRowValue'>{jobApplCountMap['SPECIAL_ARRANGEMENT'] ?? 0}<RightOutlined /></div>
                        </div>
                        <div className='flexBox selectRow' onClick={() => jump('/student/studentSeeAllJobApplications/request')}>
                            <div className='label'>IP Requested More Info</div>
                            <div className='value selectRowValue'>{(jobApplCountMap['REQUEST_DOCUMENT'] ?? 0)}<RightOutlined /></div>
                        </div>
                        <div className='flexBox selectRow' onClick={() => jump('/student/studentSeeAllJobApplications/offer')}>
                            <div className='label'>IP Made Offer</div>
                            <div className='value selectRowValue'>{jobApplCountMap['OFFER'] ?? 0}<RightOutlined /></div>
                        </div>
                    </div>
                </div>
                <div className='overviewBox'>
                    <div className='flexBox'>
                        <div className='homeTitle'>WIL Assessment Overview</div>
                        <div className='seeAllBox' onClick={() => jump('/student/studentModuleDashboard')}>To WIL Overview</div>
                    </div>
                    <div className='wilAssessmentOverview'>
                        {moduleList.length > 0 ?
                            moduleList?.map((item, index) =>
                                <div className='flexBox selectRow' key={index} onClick={() => jumpStorage('/student/studentModule', item.studentModuleId)}>
                                    <div className='label'>{item.moduleCode} {item.moduleName}</div>
                                    <div className='value selectRowValue'><RightOutlined /></div>
                                </div>
                            )
                            :
                            <div className='flexBox'>
                                <div className='label'>You have no registered module</div>
                            </div>
                        }
                    </div>
                </div>
                <div className='overviewBox'>
                    <div className='flexBox homeTitle'>User Profile</div>
                    <div className='stdApplyingThree'>
                        <div className='stdApplyingThreeTopb'>
                            <img src={vectorImg} onClick={() => jump('/student/studentDetail')} />
                            <div className='stdApplyingThreecentre'>
                                <img src={Config.studentInfo?.studentPhoto ? Config.studentPhotoImg + Config.studentInfo?.studentPhoto + '?' + Config.sasToken : studentDefaultPictureImg} />
                            </div>
                        </div>
                        <div className='stdApplyingThreeBottomBox'>
                            <div className='stdApplyingThreeBottomTitle cardTitle'>{Config.studentInfo?.firstName}&nbsp;{Config.studentInfo?.lastName}</div>
                            <div className='flexBox'>
                                <div className='label'>Student ID</div>
                                <div className='value'>{Config.studentInfo?.studentAcctId}</div>
                            </div>
                            <div className='flexBox'>
                                <div className='label'>Email</div>
                                <div className='value'>{Config.studentInfo?.email}</div>
                            </div>
                            <div className='flexBox'>
                                <div className='label'>Department</div>
                                <div className='studentInfoValue value'>{Config.studentInfo?.deptDisplayName}</div>
                            </div>
                            <div className='flexBox'>
                                <div className='label'>Programme</div>
                                <div className='studentInfoValue value'>{Config.studentInfo?.progTitle}</div>
                            </div>
                            <div className='flexBox'>
                                <div className='label'>Job Applied</div>
                                <div className='value'>{Config.studentInfo?.jobApplied}</div>
                            </div>
                            <div className='flexBox'>
                                <div className='label'>Job Offered</div>
                                <div className='value'>{Config.studentInfo?.jobOffered}</div>
                            </div>
                            <div className='flexBox'>
                                <div className='label'>WIL Module Enrolled</div>
                                <div className='value'>—</div>
                            </div>
                            <div className='flexBox'>
                                <div className='label'>WPA Completed</div>
                                <div className='value'>—</div>
                            </div>
                            <div className='flexBox'>
                                <div className='label'>WPA Hours Recorded</div>
                                <div className='value'>—</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='flexTitleBox'>
                <div className='homeTitle'>Job Management</div>
                <div className='seeAllBox' onClick={() => jump('/student/studentSeeAllJobApplications/all')}>See all job applications</div>
            </div>
            {(tablesCountOffer > 0 || tablesCountDocument > 0 || tablesCountRejected > 0 || tablesCountSpecial > 0) &&
                <div className='alertTipBox'>
                    <img src={tips}></img>
                    <div className='homeSubTitle'>ALERT: Job Application Needing Your Attention</div>
                </div>
            }
            {tablesCountOffer > 0 && <>
                <div className='flexBoxMax'>
                    <div className='statusTitleBox homeStatusMargin OFFER'>
                        {ContextHandler.getMapValue('jobApplStatusMap', 'OFFER')}
                    </div>
                </div>
                <div className='carouselCardBoxRow'>
                    {tablesOffer.length > 1 ?
                        <div className='arrowBox'>
                            <div className='arrow' onClick={() => carouselRefOffer.current.prev()}><img src={leftArrow} /></div>
                        </div>
                        :
                        <div className='arrowBox'></div>
                    }
                    <Carousel ref={carouselRefOffer} autoplay={false} dots={false}>
                        {tablesOffer?.map((item, index) =>
                            <div className='carouselCardBox' key={index}>
                                {item.map(item =>
                                    <div key={item.jobApplId} className='cardBoxDiv borderColorOFFER'>
                                        <div className='cardProgrammeRow'>
                                            <div className='cardProgrammeBox' title={item.progTitle}>
                                                <div className='cardProgrammeText'>{item.progTitle}</div>
                                            </div>
                                            <div className='cardCompanyBox' title={item.companyName}>
                                                {item.companyLogo && <img src={Config.partnerImg + item.companyLogo + '?' + Config.sasToken} />}
                                                <div className='cardProgrammeText'>{item.companyName}</div>
                                            </div>
                                        </div>
                                        <div className='cardTitleBox'>
                                            <div className='cardTitle' title={item.jobTitle}>{item.jobTitle}</div>
                                        </div>
                                        <div className='flexBox'>
                                            <div className='label'>Job ID</div>
                                            <div className='value'>
                                                {item.jobId}
                                            </div>
                                        </div>
                                        <div className='flexBox'>
                                            <div className='label'>Job Mode</div>
                                            <div className='value'>
                                                {item.positionTypeVal}
                                            </div>
                                        </div>
                                        <div className='flexBox'>
                                            <div className='label'>Work Location</div>
                                            <div className='value'>{item.workLocVal}</div>
                                        </div>
                                        <div className='flexBox'>
                                            <div className='label'>Commence-End</div>
                                            <div className='value'>
                                                {item.expCommenceDate ? moment(item.expCommenceDate).format(Config.dateFormatEn) : ''} ~ {item.expEndDate ? moment(item.expEndDate).format(Config.dateFormatEn) : ''}
                                            </div>
                                        </div>
                                        <div className='flexBox'>
                                            <div className='label'>Salary/Salary Basis</div>
                                            <div className='value'>
                                                HK$ {item.salaryRangeFrom} ~ {item.salaryRangeTo} {item.unitVal}
                                            </div>
                                        </div>
                                        <div className='flexBox'>
                                            <div className='label'>Application Deadline</div>
                                            <div className='value'>
                                                {item.lastApplyDate ? moment(item.lastApplyDate).format(Config.dateFormatEn) : ''}
                                            </div>
                                        </div>
                                        <div className='cardLine'></div>
                                        <div className='cardButtonBox' >
                                            <Button icon={<img src={inspectImg} />} className='cardButton ' onClick={() => jump('/student/studentApplyJobDetail/' + item.jobApplId)}>Review</Button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}
                    </Carousel>
                    {tablesOffer.length > 1 &&
                        <div className='arrowBox'>
                            <div className='arrow' onClick={() => tablesOfferHandleSwitch()}><img src={rightArrow} /></div>
                        </div>
                    }
                </div>
            </>}
            {tablesCountDocument > 0 && <>
                <div className='flexBoxMax'>
                    <div className='statusTitleBox homeStatusMargin REQUEST_DOCUMENT'>
                        {ContextHandler.getMapValue('jobApplStatusMap', 'REQUEST_DOCUMENT')}
                    </div>
                </div>
                <div className='carouselCardBoxRow'>
                    {tablesDocument.length > 1 ?
                        <div className='arrowBox'>
                            <div className='arrow' onClick={() => carouselRefDocument.current.prev()}><img src={leftArrow} /></div>
                        </div>
                        :
                        <div className='arrowBox'></div>
                    }
                    <Carousel ref={carouselRefDocument} autoplay={false} dots={false}>
                        {tablesDocument?.map((item, index) =>
                            <div className='carouselCardBox' key={index}>
                                {item.map(item =>
                                    <div key={item.jobApplId} className='cardBoxDiv borderColorOFFER'>
                                        <div className='cardProgrammeRow'>
                                            <div className='cardProgrammeBox' title={item.progTitle}>
                                                <div className='cardProgrammeText'>{item.progTitle}</div>
                                            </div>
                                            <div className='cardCompanyBox' title={item.companyName}>
                                                {item.companyLogo && <img src={Config.partnerImg + item.companyLogo + '?' + Config.sasToken} />}
                                                <div className='cardProgrammeText'>{item.companyName}</div>
                                            </div>
                                        </div>
                                        <div className='cardTitleBox'>
                                            <div className='cardTitle' title={item.jobTitle}>{item.jobTitle}</div>
                                        </div>
                                        <div className='flexBox'>
                                            <div className='label'>Job ID</div>
                                            <div className='value'>
                                                {item.jobId}
                                            </div>
                                        </div>
                                        <div className='flexBox'>
                                            <div className='label'>Job Mode</div>
                                            <div className='value'>
                                                {item.positionTypeVal}
                                            </div>
                                        </div>
                                        <div className='flexBox'>
                                            <div className='label'>Work Location</div>
                                            <div className='value'>{item.workLocVal}</div>
                                        </div>
                                        <div className='flexBox'>
                                            <div className='label'>Commence-End</div>
                                            <div className='value'>
                                                {item.expCommenceDate ? moment(item.expCommenceDate).format(Config.dateFormatEn) : ''} ~ {item.expEndDate ? moment(item.expEndDate).format(Config.dateFormatEn) : ''}
                                            </div>
                                        </div>
                                        <div className='flexBox'>
                                            <div className='label'>Salary/Salary Basis</div>
                                            <div className='value'>
                                                HK$ {item.salaryRangeFrom} ~ {item.salaryRangeTo} {item.unitVal}
                                            </div>
                                        </div>
                                        <div className='flexBox'>
                                            <div className='label'>Application Deadline</div>
                                            <div className='value'>
                                                {item.lastApplyDate ? moment(item.lastApplyDate).format(Config.dateFormatEn) : ''}
                                            </div>
                                        </div>
                                        <div className='cardLine'></div>
                                        <div className='cardButtonBox' >
                                            <Button icon={<img src={inspectImg} />} className='cardButton ' onClick={() => jump('/student/studentApplyJobDetail/' + item.jobApplId)}>Review</Button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}
                    </Carousel>
                    {tablesDocument.length > 1 &&
                        <div className='arrowBox'>
                            <div className='arrow' onClick={() => tablesDocumentHandleSwitch()}><img src={rightArrow} /></div>
                        </div>
                    }
                </div>
            </>}
            {tablesCountRejected > 0 && <>
                <div className='flexBoxMax'>
                    <div className='statusTitleBox homeStatusMargin REJECTED'>
                        {ContextHandler.getMapValue('jobApplStatusMap', 'REJECTED')}
                    </div>
                </div>
                <div className='carouselCardBoxRow'>
                    {tablesRejected.length > 1 ?
                        <div className='arrowBox'>
                            <div className='arrow' onClick={() => carouselRefRejected.current.prev()}><img src={leftArrow} /></div>
                        </div>
                        :
                        <div className='arrowBox'></div>
                    }
                    <Carousel ref={carouselRefRejected} autoplay={false} dots={false}>
                        {tablesRejected?.map((item, index) =>
                            <div className='carouselCardBox' key={index}>
                                {item.map(item =>
                                    <div key={item.jobApplId} className='cardBoxDiv borderColorREJECTED'>
                                        <div className='cardProgrammeRow'>
                                            <div className='cardProgrammeBox' title={item.progTitle}>
                                                <div className='cardProgrammeText'>{item.progTitle}</div>
                                            </div>
                                            <div className='cardCompanyBox' title={item.companyName}>
                                                {item.companyLogo && <img src={Config.partnerImg + item.companyLogo + '?' + Config.sasToken} />}
                                                <div className='cardProgrammeText'>{item.companyName}</div>
                                            </div>
                                        </div>
                                        <div className='cardTitleBox'>
                                            <div className='cardTitle' title={item.jobTitle}>{item.jobTitle}</div>
                                        </div>
                                        <div className='flexBox'>
                                            <div className='label'>Job ID</div>
                                            <div className='value'>
                                                {item.jobId}
                                            </div>
                                        </div>
                                        <div className='flexBox'>
                                            <div className='label'>Job Mode</div>
                                            <div className='value'>
                                                {item.positionTypeVal}
                                            </div>
                                        </div>
                                        <div className='flexBox'>
                                            <div className='label'>Work Location</div>
                                            <div className='value'>{item.workLocVal}</div>
                                        </div>
                                        <div className='flexBox'>
                                            <div className='label'>Commence-End</div>
                                            <div className='value'>
                                                {item.expCommenceDate ? moment(item.expCommenceDate).format(Config.dateFormatEn) : ''} ~ {item.expEndDate ? moment(item.expEndDate).format(Config.dateFormatEn) : ''}
                                            </div>
                                        </div>
                                        <div className='flexBox'>
                                            <div className='label'>Salary/Salary Basis</div>
                                            <div className='value'>
                                                HK$ {item.salaryRangeFrom} ~ {item.salaryRangeTo} {item.unitVal}
                                            </div>
                                        </div>
                                        <div className='flexBox'>
                                            <div className='label'>Application Deadline</div>
                                            <div className='value'>
                                                {item.lastApplyDate ? moment(item.lastApplyDate).format(Config.dateFormatEn) : ''}
                                            </div>
                                        </div>
                                        <div className='cardLine'></div>
                                        <div className='cardButtonBox' >
                                            <Button icon={<img src={inspectImg} />} className='cardButton ' onClick={() => jump('/student/studentApplyJobDetail/' + item.jobApplId)}>Review</Button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}
                    </Carousel>
                    {tablesRejected.length > 1 &&
                        <div className='arrowBox'>
                            <div className='arrow' onClick={() => tablesRejectedHandleSwitch()}><img src={rightArrow} /></div>
                        </div>
                    }
                </div>
            </>}
            {tablesCountSpecial > 0 && <>
                <div className='flexBoxMax'>
                    <div className='statusTitleBox homeStatusMargin SPECIAL_ARRANGEMENT'>
                        {ContextHandler.getMapValue('jobApplStatusMap', 'SPECIAL_ARRANGEMENT')}
                    </div>
                </div>
                <div className='carouselCardBoxRow'>
                    {tablesSpecial.length > 1 ?
                        <div className='arrowBox'>
                            <div className='arrow' onClick={() => carouselRefSpecial.current.prev()}><img src={leftArrow} /></div>
                        </div>
                        :
                        <div className='arrowBox'></div>
                    }
                    <Carousel ref={carouselRefSpecial} autoplay={false} dots={false}>
                        {tablesSpecial?.map((item, index) =>
                            <div className='carouselCardBox' key={index}>
                                {item.map(item =>
                                    <div key={item.jobApplId} className='cardBoxDiv borderColorOFFER'>
                                        <div className='cardProgrammeRow'>
                                            <div className='cardProgrammeBox' title={item.progTitle}>
                                                <div className='cardProgrammeText'>{item.progTitle}</div>
                                            </div>
                                            <div className='cardCompanyBox' title={item.companyName}>
                                                {item.companyLogo && <img src={Config.partnerImg + item.companyLogo + '?' + Config.sasToken} />}
                                                <div className='cardProgrammeText'>{item.companyName}</div>
                                            </div>
                                        </div>
                                        <div className='cardTitleBox'>
                                            <div className='cardTitle' title={item.jobTitle}>{item.jobTitle}</div>
                                        </div>
                                        <div className='flexBox'>
                                            <div className='label'>Job ID</div>
                                            <div className='value'>
                                                {item.jobId}
                                            </div>
                                        </div>
                                        <div className='flexBox'>
                                            <div className='label'>Job Mode</div>
                                            <div className='value'>
                                                {item.positionTypeVal}
                                            </div>
                                        </div>
                                        <div className='flexBox'>
                                            <div className='label'>Work Location</div>
                                            <div className='value'>{item.workLocVal}</div>
                                        </div>
                                        <div className='flexBox'>
                                            <div className='label'>Commence-End</div>
                                            <div className='value'>
                                                {item.expCommenceDate ? moment(item.expCommenceDate).format(Config.dateFormatEn) : ''} ~ {item.expEndDate ? moment(item.expEndDate).format(Config.dateFormatEn) : ''}
                                            </div>
                                        </div>
                                        <div className='flexBox'>
                                            <div className='label'>Salary/Salary Basis</div>
                                            <div className='value'>
                                                HK$ {item.salaryRangeFrom} ~ {item.salaryRangeTo} {item.unitVal}
                                            </div>
                                        </div>
                                        <div className='flexBox'>
                                            <div className='label'>Application Deadline</div>
                                            <div className='value'>
                                                {item.lastApplyDate ? moment(item.lastApplyDate).format(Config.dateFormatEn) : ''}
                                            </div>
                                        </div>
                                        <div className='cardLine'></div>
                                        <div className='cardButtonBox' >
                                            <Button icon={<img src={inspectImg} />} className='cardButton ' onClick={() => jump('/student/studentApplyJobDetail/' + item.jobApplId)}>Review</Button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}
                    </Carousel>
                    {tablesSpecial.length > 1 &&
                        <div className='arrowBox'>
                            <div className='arrow' onClick={() => tablesSpecialHandleSwitch()}><img src={rightArrow} /></div>
                        </div>
                    }
                </div>
            </>}

            <div className='flexTitleBox homeSubTitle'>Manage Job Applications</div>
            <div className='websiteSysSearchRow'>
                <div className='websiteSysSearchBar'>
                    <input style={{ paddingLeft: '11px' }} placeholder="Search By job title or by job ID"
                        value={jobPostModel?.jobTitle || ''}
                        onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1) : null}
                        onChange={(e) => modelChange("jobTitle", e.target.value)} />
                    <img src={searchImg} onClick={() => search(pageSize, 1)} />
                </div>
                <Popover placement="topRight" trigger="click" open={popoverVisible}
                    onOpenChange={handleOpenChange} content={
                        <StudentSeeAllJobApplicationsSort isReset={isReset} onOpenChange={handleOpenChange2} />
                    }
                    getPopupContainer={() => document.getElementById('sortButton')}
                >
                    <div className='websiteSysButton sortButton' id='sortButton'><img src={sortImg} />Sort</div>
                </Popover>
                <div className='websiteSysButton sortButton' onClick={reset}><img src={resetImg} />Reset</div>
            </div>
            <div className="sysTable" id="tableOne">
                <Table
                    scroll={{ x: 1200 }}
                    rowKey="jobApplId"
                    columns={columns} //列名
                    dataSource={tables} //数据
                    pagination={{  //分页
                        showSizeChanger: true,                          //是否显示可以设置几条一页的选项
                        onChange: onChange,            //上页下页或者跳页方法
                        onShowSizeChange: onShowSizeChange,    //每页显示多少条数据方法
                        total: tablesCount,             //总共多少条数据
                        current: current,         //当前页
                        pageSize: pageSize,       //每页显示多少条数据
                        defaultCurrent: 1,                               //默认当前页为1
                        size: "small"
                    }}
                    onChange={handleTableChange}
                />
            </div>
            <div className='flexBoxMax'>
                <div className='homeTitle'>Jobs You Can Apply For WIL</div>
                <div className='seeAllBox' onClick={() => jump('/student/studentSeeAllJobPosting')}>See all job postings</div>
            </div>
            {tablesCountAssigned > 0 && <>
                <div className='flexBoxMax'>
                    <div className='statusTitleBox homeStatusMargin ASSIGNED' style={{ backgroundColor: '#CDE7FF', color: '#0059AC' }}>
                        Assigned
                    </div>
                </div>
                <div className='carouselCardBoxRow'>
                    {tablesAssigned.length > 1 ?
                        <div className='arrowBox'>
                            <div className='arrow' onClick={() => carouselRefAssigned.current.prev()}><img src={leftArrow} /></div>
                        </div>
                        :
                        <div className='arrowBox'></div>
                    }
                    <Carousel ref={carouselRefAssigned} autoplay={false} dots={false}>
                        {tablesAssigned?.map((item, index) =>
                            <div className='carouselCardBox' key={index}>
                                {item.map(item =>
                                    <div key={item.jobId} className='cardBoxDiv borderColorPosts'>
                                        <div className='cardProgrammeRow'>
                                            <div className='cardProgrammeBox' title={item.progTitle}>
                                                <div className='cardProgrammeText'>{item.progTitle}</div>
                                            </div>
                                            <div className='cardCompanyBox' title={item.companyName}>
                                                {item.companyLogo && <img src={Config.partnerImg + item.companyLogo + '?' + Config.sasToken} />}
                                                <div className='cardProgrammeText'>{item.companyName}</div>
                                            </div>
                                        </div>
                                        <div className='cardTitleBox'>
                                            <div className='cardTitle' title={item.jobTitle}>{item.jobTitle}</div>
                                        </div>
                                        <div className='flexBox'>
                                            <div className='label'>Job ID</div>
                                            <div className='value'>
                                                {item.jobId}
                                            </div>
                                        </div>
                                        <div className='flexBox'>
                                            <div className='label'>Job Mode</div>
                                            <div className='value'>
                                                {item.positionTypeVal}
                                            </div>
                                        </div>
                                        <div className='flexBox'>
                                            <div className='label'>Work Location</div>
                                            <div className='value'>{item.workLocVal}</div>
                                        </div>
                                        <div className='flexBox'>
                                            <div className='label'>Commence-End</div>
                                            <div className='value'>
                                                {item.expCommenceDate ? moment(item.expCommenceDate).format(Config.dateFormatEn) : ''} ~ {item.expEndDate ? moment(item.expEndDate).format(Config.dateFormatEn) : ''}
                                            </div>
                                        </div>
                                        <div className='flexBox'>
                                            <div className='label'>Salary/Salary Basis</div>
                                            <div className='value'>
                                                HK$ {item.salaryRangeFrom} ~ {item.salaryRangeTo} {item.unitVal}
                                            </div>
                                        </div>
                                        <div className='flexBox'>
                                            <div className='label'>Application Deadline</div>
                                            <div className='value'>
                                                {item.lastApplyDate ? moment(item.lastApplyDate).format(Config.dateFormatEn) : ''}
                                            </div>
                                        </div>
                                        <div className='cardLine'></div>
                                        <div className='cardButtonBox' >
                                            <Button icon={<img src={inspectImg} />} className='cardButton ' onClick={() => jump('/student/studentJobDetail/' + item.jobId + '/assigned')}>Review</Button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}
                    </Carousel>
                    {tablesAssigned.length > 1 &&
                        <div className='arrowBox'>
                            <div className='arrow' onClick={() => tablesAssignedHandleSwitch()}><img src={rightArrow} /></div>
                        </div>
                    }
                </div>
            </>}
            {Base.isEmpty(tablesJob) && Base.isEmpty(tablesAssigned) ? <Empty /> : ''}
            {tablesCountJob > 0 && <>
                <div className='flexBoxMax'>
                    <div className='statusTitleBox homeStatusMargin ASSIGNED' style={{ backgroundColor: '#CDE7FF', color: '#0059AC' }}>
                        Job Posts
                    </div>
                </div>
                <div className='carouselCardBoxRow'>
                    {tablesJob.length > 1 ?
                        <div className='arrowBox'>
                            <div className='arrow' onClick={() => carouselRef.current.prev()}><img src={leftArrow} /></div>
                        </div>
                        :
                        <div className='arrowBox'></div>
                    }
                    <Carousel ref={carouselRef} autoplay={false} dots={false}>
                        {tablesJob?.map((item, index) =>
                            <div className='carouselCardBox' key={index}>
                                {item.map(item =>
                                    <div key={item.jobId} className='cardBoxDiv borderColorPosts'>
                                        <div className='cardProgrammeRow'>
                                            <div className='cardProgrammeBox' title={item.progTitle}>
                                                <div className='cardProgrammeText'>{item.progTitle}</div>
                                            </div>
                                            <div className='cardCompanyBox' title={item.companyName}>
                                                {item.companyLogo && <img src={Config.partnerImg + item.companyLogo + '?' + Config.sasToken} />}
                                                <div className='cardProgrammeText'>{item.companyName}</div>
                                            </div>
                                        </div>
                                        <div className='cardTitleBox'>
                                            <div className='cardTitle' title={item.jobTitle}>{item.jobTitle}</div>
                                        </div>
                                        <div className='flexBox'>
                                            <div className='label'>Job ID</div>
                                            <div className='value'>
                                                {item.jobId}
                                            </div>
                                        </div>
                                        <div className='flexBox'>
                                            <div className='label'>Job Mode</div>
                                            <div className='value'>
                                                {item.positionTypeVal}
                                            </div>
                                        </div>
                                        <div className='flexBox'>
                                            <div className='label'>Work Location</div>
                                            <div className='value'>{item.workLocVal}</div>
                                        </div>
                                        <div className='flexBox'>
                                            <div className='label'>Commence-End</div>
                                            <div className='value'>
                                                {item.expCommenceDate ? moment(item.expCommenceDate).format(Config.dateFormatEn) : ''} ~ {item.expEndDate ? moment(item.expEndDate).format(Config.dateFormatEn) : ''}
                                            </div>
                                        </div>
                                        <div className='flexBox'>
                                            <div className='label'>Salary/Salary Basis</div>
                                            <div className='value'>
                                                HK$ {item.salaryRangeFrom} ~ {item.salaryRangeTo} {item.unitVal}
                                            </div>
                                        </div>
                                        <div className='flexBox'>
                                            <div className='label'>Application Deadline</div>
                                            <div className='value'>
                                                {item.lastApplyDate ? moment(item.lastApplyDate).format(Config.dateFormatEn) : ''}
                                            </div>
                                        </div>
                                        <div className='cardLine'></div>
                                        <div className='cardButtonBox' >
                                            <Dropdown trigger={['hover']}
                                                destroyPopupOnHide={true}
                                                placement="bottomLeft"
                                                dropdownRender={() =>
                                                    <div >
                                                        <Button icon={<img src={select1} />} onClick={() => jump('/student/studentJobDetail/' + item.jobId + '/view')}>Review</Button>
                                                        {item.lastApplyDate >= moment().startOf('day').valueOf() && <Button icon={<img src={select3} />} onClick={() => jump('/student/studentJobDetail/' + item.jobId + '/apply')}>Apply</Button>}
                                                    </div>
                                                }
                                            >
                                                <Button icon={<img src={stdApplyingAction} />} className='cardButton '>Action</Button>
                                            </Dropdown>
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}
                    </Carousel>
                    {tablesJob.length > 1 &&
                        <div className='arrowBox'>
                            <div className='arrow' onClick={() => tablesJobHandleSwitch()}><img src={rightArrow} /></div>
                        </div>
                    }
                </div>
            </>}
        </div >
    )

}

export default StudentHome;